export default __webpack_public_path__ + "static/utility-hero-4c46ffa912a653848a2bf005ac820818.jpg";